<template>
  <div>
    <div class="bg-evm-grey mobile-view">
      <b-container fluid class="p-0">
        <b-row class="no-gutters mobile-view">
          <!--
          <b-col class="col-5 col-md-2 col-lg-1"><a href="https://www.evm.de/evm/Homepage/Impressum/" target="_blank"
                                                    class="link">Impressum</a></b-col>
          <b-col class="col-5 col-md-2 col-lg-1"><a href="https://www.evm.de/evm/Homepage/Impressum/#datenschutz"
                                                    target="_blank" class="link">Datenschutz</a></b-col>
          <b-col class="d-none d-lg-block col-lg-5">&nbsp;</b-col>-->
          <b-col class="col-2 d-none d-md-block col-md-7">
            &nbsp;
          </b-col>
          <b-col class="col-5 col-md-4 col-lg-3 link mt-5 mb-5">
            <strong>Energieversorgung Mittelrhein AG</strong><br/>
            Ludwig-Erhard-Straße 8<br/>
            56073 Koblenz <br/>
            <br/>
            Telefon: 0261 402-11111<br/>
            Fax: 0261 402-61499<br/>
            <div v-if="$route.fullPath.includes('standrohr')">
              E-Mail: <a href="mailto:standrohre@enm.de" class="link">standrohre@enm.de</a>
            </div>
            <div v-else>
              E-Mail: <a href="mailto:info@evm.de" class="link">info@evm.de</a>
            </div>
          </b-col>
          <div class="w-100 pt-2 d-sm-none"></div>
          <!-- <b-col class="col-5 col-md-2 col-lg-1"><a href="https://www.evm.de/evm/Homepage/Impressum/" target="_blank" class="link">Impressum</a> </b-col>
          <b-col class="col-5 col-md-2 col-lg-1"><a href="https://www.evm.de/datenschutz/" target="_blank" class="link">Datenschutz</a> </b-col>-->
        </b-row>
        <b-row class="no-gutters bg-white p-0">
          <b-col class="col-lg-6">
            <b-container fluid>
              <b-row class=" mt-3 mb-5 ml-0">
                <b-col cols="1" class="d-none d-lg-block">
                  &nbsp;
                </b-col>
                <b-col class="col-md-1 d-none d-md-block">
                  &nbsp;
                </b-col>
                <div class="w-100 pt-2 d-sm-none"></div>
                <b-col>
                  <ul class="ul-list">
                    <li>
                      <a href="https://www.evm.de/impressum/" class="text-evm-orange" target="_blank">Impressum</a>
                    </li>
                    <li>
                      <a href="https://www.evm.de/datenschutz/" class="text-evm-orange" target="_blank">Datenschutz</a>
                    </li>
                    <li>
                      <a href="https://www.evm.de/kontakt/" class="text-evm-orange" target="_blank">Kontakt</a>
                    </li>
                    <li>
                      <a href="https://www.evm.de/" class="text-evm-orange" target="_blank">evm</a>
                    </li>
                  </ul>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
          <div class="w-100 pt-2 d-sm-none"></div>
          <b-col class="col-lg-6">
            <b-container>
              <b-row>
                <b-col>
                  <ul class="ul-list-media">
                    <li>
                      <a href="https://www.facebook.com/meine.evm" target="_blank"><img src="../assets/facebook-round.svg" width="44" height="44"></a>
                    </li>
                    <li>
                      <a href="https://twitter.com/meine_evm" target="_blank"><img src="../assets/twitter-round.svg" width="44" height="44"></a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/meine_evm/" target="_blank"><img src="../assets/instagram-round.svg" width="44" height="44"></a>
                    </li>
                    <li>
                      <a href="https://www.youtube.com/channel/UCku_I9avm2aSmrTCxLZX4ZA" target="_blank"><img src="../assets/youtube-kreis.svg" width="44" height="44"></a>
                    </li>
                    <li>
                      <a href="https://www.evm.de/kontakt/#whatsapp" target="_blank"><img src="../assets/whatsapp-round.svg" width="44" height="44"></a>
                    </li>
                    <li>
                      <a href="https://www.xing.com/companies/energieversorgungmittelrheinag" target="_blank"><img src="../assets/xing-round.svg" width="44" height="44"></a>
                    </li>
                  </ul>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {}
  }
}
</script>
